var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DateTimePicker',{key:_vm.item.uuid,staticClass:"w-full form-input--small",attrs:{"value":_vm.item.response,"enable-date":_vm.item.params.date,"enable-time":_vm.item.params.time},on:{"change":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }